import { Theme, useMediaQuery } from '@c2fo/react-components';

export const IS_MOBILE_QUERY = (theme: Theme) => theme.breakpoints.down('sm');

export function useIsMobile() {
  return useMediaQuery(IS_MOBILE_QUERY);
}
